import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePicker.css';
import customLocale from '../../../constants/customLocale';

/**
 * A customizable DatePicker component built with React and `react-datepicker`.
 * This component allows users to select a date visually from a calendar, with support
 * for month/year navigation, clearing the selected date, and using default dates.
 *
 * Props:
 * - `defaultDate` (Date, optional): The initial pre-selected date.
 * - `isClearable` (boolean, default=false): Enables the clear button to reset the date.
 * - `onDateChange` (function): Callback to return the selected date to the parent component.
 * - `dateFormat` (string, default="MMMM d, yyyy"): Format for displaying the date.
 * - `placeholderText` (string, default="Select a date"): Placeholder text when no date is selected.
 */
function CustomDatePicker({
  defaultDate,
  isClearable = false,
  onDateChange,
  dateFormat = 'MMMM d, yyyy',
  placeholderText = 'Select a date',
}) {
  const [isOpen, setIsOpen] = useState(false);
  const date = defaultDate ? defaultDate : null;

  const handleChange = (date) => {
    if (onDateChange) {
      onDateChange(date);
    }
  };

  return (
    <div className="custom-date-picker">
      {isOpen && <div className="custom-datepicker-overlay" />}
      <DatePicker
        selected={date}
        onChange={handleChange}
        dateFormat={dateFormat}
        isClearable={isClearable}
        placeholderText={placeholderText}
        locale={customLocale}
        onCalendarOpen={() => setIsOpen(true)}
        onCalendarClose={() => setIsOpen(false)}
      />
    </div>
  );
}

export default CustomDatePicker;
